import React, { memo, useCallback, useState } from 'react';
import { Button } from 'components/ui/button';
import { Label } from 'components/ui/label';
import { RadioGroup, RadioGroupItem } from 'components/ui/radio-group';
import { Card, CardContent } from 'components/ui/card';
import { IconSearch } from '@app/icons';
import { Company, Tender, TenderTypes } from '@app/models';
import { RenderFilterProps } from '@app/templates';
import TendersFilter from '../TendersFilter';
import { useLocation } from 'react-router-dom';
import { cn } from 'lib/utils';

export type ContractorsFilterData<T> = {
  tenderType: TenderTypes;
} & Partial<T>;

interface Props
  extends RenderFilterProps<ContractorsFilterData<Company | Tender>> {}

function ContractorsFilter(props: Props) {
  const { onSubmit, pending, okedParentNumber } = props;
  const [tenderType, setTenderType] = useState<TenderTypes>(
    TenderTypes.REQUEST
  );
  const location = useLocation();
  const isSuppliers = location.pathname.includes('suppliers');

  const onChangeTenderType = useCallback(
    (item: TenderTypes) => {
      setTenderType(item);
      onSubmit({ tenderType: item });
    },
    [onSubmit]
  );

  const onSubmitTendersFilter = useCallback(
    (tenderFilterData: Partial<Tender>) => {
      onSubmit({
        tenderType,
        ...tenderFilterData,
      });
    },
    [onSubmit, tenderType]
  );

  return (
    <Card className="w-full rounded-t-none border-0 shadow-none">
      <CardContent className="p-0">
        <div className="mb-6">
          <RadioGroup
            value={tenderType.toString()}
            onValueChange={(value) =>
              onChangeTenderType(parseInt(value) as TenderTypes)
            }
            className="flex flex-col gap-4 sm:flex-row sm:gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                value={TenderTypes.REQUEST.toString()}
                id="request"
              />
              <Label
                htmlFor="request"
                className="text-sm font-medium cursor-pointer"
              >
                {isSuppliers ? 'Список материалов' : 'Список заявок на подряд'}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value={TenderTypes.OFFER.toString()} id="offer" />
              <Label
                htmlFor="offer"
                className="text-sm font-medium cursor-pointer"
              >
                {isSuppliers ? 'Список поставщиков' : 'Список подрядчиков'}
              </Label>
            </div>
          </RadioGroup>
        </div>
        <TendersFilter
          pending={pending}
          onSubmit={onSubmitTendersFilter}
          okedParentNumber={okedParentNumber}
        />
      </CardContent>
    </Card>
  );
}

export default memo(ContractorsFilter);
